// @flow
import React from 'react';
import { isEmpty } from 'lodash';

import { COLORS } from 'Components/utils/color/colors';

import { Title } from 'Components/frameworks/title/Title.jsx';

import {
  ProductFeatureDetailFacility,
  type ProductFeatureDetailFacilityProps,
} from './ProductFeatureDetailFacility.jsx';

type Props = {
  className?: string,
  items: Array<ProductFeatureDetailFacilityProps>,
  color?: Colors,
  title?: string,
};

export function ProductFeatureDetailFacilities(props: Props) {
  const { className, color = COLORS.BLUE, items = [], title = '' } = props;

  if (!items.length) {
    return null;
  }

  return (
    <section className={className}>
      <Title color={color} hLevel={4} theme="title-brand-3">
        {title}
      </Title>
      <ul className="sm:colum-count-2 list-none p-0 my-3">
        {items.map((item, idx) => {
          return (
            !isEmpty(item) && (
              <li
                className={`break-inside-avoid-column my-3${idx === 0 ? ' mt-0' : ''}`}
                key={item.id}
              >
                <ProductFeatureDetailFacility {...item} />
              </li>
            )
          );
        })}
      </ul>
    </section>
  );
}
